export var LAYOUT;
(function (LAYOUT) {
    LAYOUT["GRID"] = "GRID";
    LAYOUT["FOCUSED"] = "FOCUSED";
})(LAYOUT || (LAYOUT = {}));
//# sourceMappingURL=video.js.map